import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["initial", "transition", "whileHover"]

import { computed } from "vue";

type Orientation = "x" | "y" | "none";

// 1. Removed 'class' from props because Vue handles attribute fallthrough automatically

export default /*@__PURE__*/_defineComponent({
  __name: 'AnimatedBox',
  props: {
    orientation: { default: "y" },
    offset: { default: 80 },
    hover: {},
    delay: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

// 2. Compute the initial state based on orientation and offset
const computedInitial = computed(() => {
  const base = { opacity: 0 };

  if (props.orientation === "x") {
    return { ...base, x: props.offset, y: 0 };
  }

  if (props.orientation === "y") {
    return { ...base, y: props.offset, x: 0 };
  }

  return base;
});

// 3. Define the transition config.  animate values are static (opacity 1, x 0, y 0).
const transitionConfig = computed(() => ({
  type: "spring",
  stiffness: 140,
  damping: 18,
  mass: 1.8,
  delay: props.delay, // Extracted to a prop for max reusability!
}));

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    initial: computedInitial.value,
    animate: { opacity: 1, x: 0, y: 0 },
    transition: transitionConfig.value,
    whileHover: props.hover
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1)), [
    [_directive_motion]
  ])
}
}

})